export default __webpack_public_path__ + "static/media/10.dbf31e5b.jpg";